import { format } from "date-fns";
import { 
    Box, 
    Typography, 
    Button, 
    Card, 
    CardContent, 
    Stack, 
    CircularProgress 
} from "@mui/material";
import { Download } from "@mui/icons-material";


const ProductCatalog = ({ 
    cachedCount, 
    lastCached, 
    loading, 
    isOnline, 
    onDownload 
}) => (
    <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
            <Stack 
                direction="row" 
                justifyContent="space-between" 
                alignItems="center"
            >
                <Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                        Product Catalog
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {cachedCount > 0
                            ? `${cachedCount} products cached${lastCached ? ` · ${format(lastCached, "HH:mm dd/MM")}` : ""}`
                            : "Not cached yet"}
                    </Typography>
                </Box>
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={loading ? <CircularProgress size={14} /> : <Download />}
                    onClick={onDownload}
                    disabled={!isOnline || loading}
                >
                    {loading ? "Downloading…" : "Download"}
                </Button>
            </Stack>
        </CardContent>
    </Card>
);

export default ProductCatalog;
